// One way to write a size everywhere: "10G", "10 g", "10г" -> "10g". Words are left alone ("Цеглина 250g").
export function formatSize(size) {
  if (!size) return '';
  return String(size).trim().replace(/(\d)\s*[gGгГ](?![A-Za-zА-Яа-яІіЇїЄєҐґ])/g, '$1g');
}

// Same, with a space between the number and the unit ("10g" -> "10 g"): how a size reads next to a price.
export function formatSizeSpaced(size) {
  return formatSize(size).replace(/(\d)([^\d\s]+)$/, '$1 $2');
}
